import { Injectable } from '@angular/core';
import {
  RouterStateSnapshot, ActivatedRouteSnapshot
} from '@angular/router';
import { RIGHT_NAV_TRANSLATION_BASE_PATH } from '~core/components/right-nav-breadcrumb-constants';
import { TranslatePipe } from '~shared/pipes/translate.pipe';
import { AppState } from '~core/states/app/app.state';

@Injectable({
  providedIn: 'root'
})
export class FacilitySettingsResolver  {

  constructor(
    private translate: TranslatePipe,
    private appState: AppState
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {    
    const translatePath = `${RIGHT_NAV_TRANSLATION_BASE_PATH}.DisplayName.Facility Settings`;
    
    const translatedTitle = this.translate.transform(translatePath);

    this.appState.set('pageTitle', translatedTitle);
  }
}